import { StyleSheet, Image } from "react-native";
import React from "react";
import { Box, Heading, Text } from "native-base";
import { LinearGradient } from "expo-linear-gradient";

type BoxProps = React.ComponentProps<typeof Box>;
export interface CardProps extends BoxProps {
  heading: string;
  subheading: string;
  details: string;
  iconName?: string;
  image?: any;
  bg?: string;
  cardShadow?: any;
  onPress: () => void;
}

const Card = (props: CardProps) => {
  const {
    heading,
    subheading,
    details,
    iconName,
    image,
    bg,
    cardShadow,
    onPress,
  } = props;

  return (
    <Box
      style={cardShadow || styles.cardShadow}
      w={"5/6"}
      bg={bg || "#6A3F24"}
      borderRadius={30}
      mx="auto"
      p={"5"}
      justifyContent="center"
    >
      {image && (
        <Image
          source={image}
          resizeMode="contain"
          style={{
            width: 30,
            height: 30,
            marginBottom: 15,
            alignSelf: "center",
          }}
        />
      )}
      <Heading
        size={"sm"}
        textAlign="center"
        fontWeight={"extrabold"}
        fontFamily="Roboto"
      >
        {heading}
      </Heading>

      {subheading && (
        <Box
          width={"5/6"}
          // h="16"
          mt={5}
          margin="auto"
          // borderBottomColor="#000"
          borderColor={"#fff"}
          borderWidth="1"
          borderRadius={15}
          {...props}
          p={2}
          py={3}
        >
          <Heading size="sm" textAlign="center" fontWeight="bold">
            {subheading}
          </Heading>
        </Box>
      )}

      {details && (
        <Text mt={10} textAlign="center" fontSize="xs">
          {details}
        </Text>
      )}
    </Box>
  );
};

export default Card;

const styles = StyleSheet.create({
  buttonShadow: {
    shadowOffset: { width: -2, height: 2 },
    shadowRadius: 3,
    shadowOpacity: 0.8,
    shadowColor: "#000000",
    elevation: 20,
    borderWidth: 1,
    borderTopColor: "#ccc",
    borderLeftColor: "#999",
    borderColor: "#333",
  },
  cardShadow: {
    shadowOpacity: 0.8,
    shadowOffset: { width: 0, height: 20 },
    shadowRadius: 10,
    // elevation: 20,
    shadowColor: "#000000",
  },
});
